import { render, staticRenderFns } from "./CPP_PptReactions.vue?vue&type=template&id=069d3752&scoped=true&"
import script from "./CPP_PptReactions.vue?vue&type=script&lang=js&"
export * from "./CPP_PptReactions.vue?vue&type=script&lang=js&"
import style0 from "./CPP_PptReactions.vue?vue&type=style&index=0&id=069d3752&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069d3752",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VContainer,VSelect})
